// Stripe price and product IDs for Sentinela de Caixa

// NEW NAMING CONVENTION (Conversion-optimized):
// Essencial = Sentinela (clareza mensal)
// Profissional = Premium (proteção preditiva) - RECOMENDADO
// Estratégico = Ultra (controle total)

export const STRIPE_PLANS = {
  // Plano Essencial (anteriormente Sentinela) - R$ 97/mês
  sentinela_monthly: {
    price_id: "price_1StqiiA29wXfRX42HOlQREah",
    product_id: "prod_TrZso7Icb2yjMZ",
    tier: "sentinela" as const,
    name: "Essencial",
    displayName: "Essencial",
    price: 97,
    interval: "mês",
    description: "Clareza mensal do seu negócio",
  },
  sentinela_annual: {
    price_id: "price_1StqkmA29wXfRX424cbDul10",
    product_id: "prod_TrZuaY54umBIUg",
    tier: "sentinela" as const,
    name: "Essencial",
    displayName: "Essencial",
    price: 970,
    interval: "ano",
    description: "Clareza mensal do seu negócio",
    savings: "2 meses grátis",
  },
  // Plano Profissional (anteriormente Premium) - R$ 297/mês - RECOMENDADO
  premium_monthly: {
    price_id: "price_1Stu7oA29wXfRX421mW873ut",
    product_id: "prod_TrdODhmVmAohSu",
    tier: "premium" as const,
    name: "Profissional",
    displayName: "Profissional",
    price: 297,
    interval: "mês",
    description: "Proteção preditiva contra surpresas",
    recommended: true,
  },
  premium_annual: {
    price_id: "price_1StqlJA29wXfRX42frVyaHSx",
    product_id: "prod_TrZvUwIlpKOARg",
    tier: "premium" as const,
    name: "Profissional",
    displayName: "Profissional",
    price: 2970,
    interval: "ano",
    description: "Proteção preditiva contra surpresas",
    savings: "2 meses grátis",
    recommended: true,
  },
  // Plano Estratégico (anteriormente Ultra) - R$ 697/mês
  ultra_monthly: {
    price_id: "price_1Stu8fA29wXfRX42Dfr4FCXx",
    product_id: "prod_TrdPYx6TcqXm9y",
    tier: "ultra" as const,
    name: "Estratégico",
    displayName: "Estratégico",
    price: 697,
    interval: "mês",
    description: "Controle total com módulo Cardápio",
  },
  ultra_annual: {
    price_id: "price_1Stu8uA29wXfRX42MWNiKkho",
    product_id: "prod_TrdP5diXlFXWdj",
    tier: "ultra" as const,
    name: "Estratégico",
    displayName: "Estratégico",
    price: 5790,
    interval: "ano",
    description: "Controle total com módulo Cardápio",
    savings: "12x R$ 579",
  },
} as const;

export type PlanType = keyof typeof STRIPE_PLANS;
export type PlanTier = "sentinela" | "premium" | "ultra";

// Helper to get plan tier from product ID
export function getPlanTierFromProductId(productId: string): PlanTier | null {
  for (const plan of Object.values(STRIPE_PLANS)) {
    if (plan.product_id === productId) {
      return plan.tier;
    }
  }
  return null;
}

// Features for each tier
export const PLAN_FEATURES = {
  sentinela: [
    "Diagnóstico mensal completo",
    "Índice de saúde do caixa",
    "Alertas claros de risco",
    "Histórico de 3 meses",
    "Relatório em PDF",
  ],
  premium: [
    "Tudo do plano Sentinela, mais:",
    "Alertas preditivos de risco",
    "Radar Sentinela completo",
    "Leitura de tendência contínua",
    "Alertas proativos WhatsApp",
    "Relatório PDF premium",
  ],
  ultra: [
    "Tudo do plano Premium, mais:",
    "Módulo Cardápio com IA",
    "Enviar para Sócios (PDF)",
    "Sugestões de precificação",
    "Suporte prioritário",
  ],
} as const;

// Plan display names for UI (conversion-optimized)
export const PLAN_DISPLAY_NAMES = {
  sentinela: "Essencial",
  premium: "Profissional", 
  ultra: "Estratégico",
} as const;

// Tagline global do produto
export const PRODUCT_TAGLINE = "Clareza financeira diária antes do prejuízo aparecer.";
